// Module
var code = "<a ng-click=\"navigate()\" id=\"tab-inprogress-link-large-screen\" class=\"tab-inprogress-link waves-effect waves-blue\" href=\"#\"><i class=\"{{item.icon}}\"></i>{{item.name}}<span ng-if=\"item.status\" class=\"badge\">{{item.status}}</span></a> ";
// Exports
export default code;